import * as React from 'react';
import { get } from 'lodash';
import { Field } from 'redux-form';

import { Card } from 'material-ui/Card';
import FileUploadIcon from 'material-ui/svg-icons/file/file-upload';
import FileThumb from 'material-ui/svg-icons/action/account-box';
import { FormUpload } from '@inqool/uas-web-core/es/components/controls/Upload';

import * as T from '@components/form/Photo/_photoTypes';

const Preview = props =>
  props.disabled ? (
    <span>Nebyl zvolen žádný soubor</span>
  ) : (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
      }}
    >
      <FileUploadIcon /> Vybrat
    </span>
  );

const Photo: React.SFC<T.OutterProps & T.InnerProps> = props => (
  <React.Fragment>
    <Card
      style={{ width: '100%' }}
      containerStyle={{
        height: 300,
        padding: 5,
        marginBottom: 5,
        display: 'flex',
        alignItems: 'center'
      }}
    >
      {get(props, 'input.value.id') ? (
        <img
          src={`/metropolis/api/files/${props.input.value.id}`}
          alt="photo"
          style={{ maxWidth: '100%', maxHeight: 300, display: 'block', margin: '0 auto' }}
        />
      ) : (
        <FileThumb style={{ width: 50, height: 50, display: 'block', margin: '0 auto', color: '#bbb' }} />
      )}
    </Card>
    <FormUpload {...props} View={Preview} url="/metropolis/api/files/" fullWidth={true} />
  </React.Fragment>
);

export default Photo;

export class PhotoField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/Photo/Photo.tsx